import crudState from '../utils/crud/state'
import * as crudGetters from '../utils/crud/getters'
import * as crudMutations from '../utils/crud/mutations'
import * as crudActions from '../utils/crud/actions'
import axios from '@/plugins/axios'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'

export default {
  namespaced: true,
  state: () => ({
    endpoint: 'notificaciones/vernotificacionesSlo',
    ...crudState(),
    allNav: {},
    allPaginationNav: {}
  }),
  getters: {
    ...crudGetters,
    allNav: state => state.allNav,
    allPaginationNav: state => state.allPaginationNav
  },
  mutations: {
    ...crudMutations,
    setAllNav (state, data) {
      state.allNav = data
    },
    setAllPaginationNav (state, data) {
      state.allPaginationNav = data
    }
  },
  actions: {
    ...crudActions,
    async getAllWLNav ({ commit, state }, params) {
      const force = get(params, 'force', false)
      const query = get(params, 'query', {})

      if (force || !state.fetched || isEmpty(state.all)) {
        try {
          const response = await axios.get(`${state.endpoint}/get`, { params: query })
          const data = get(response, 'data.data', [])
          const pagination = get(response, 'data.pagination', [])
          commit('setAllNav', data)
          commit('setAllPaginationNav', pagination)
          commit('setPagination', pagination)

          return data
        } catch (e) {
          return Promise.reject(e)
        }
      }
    }
  }
}
